// extracted by mini-css-extract-plugin
export default {"iconList":"styles_iconList__90Nlk","icon":"styles_icon__qDVy7"};